// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__c+J2b","active":"Navbar_active__XkCyB","link":"Navbar_link__HIE+e"};